import './App.css';
import React, {useEffect} from 'react';
import { useCriiptoVerify } from '@criipto/verify-react';
import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Signature() {
  const {isLoading, isInitializing, loginWithRedirect, result} = useCriiptoVerify();
  const [, setCookie] = useCookies(['callbackURI']);
  const query = useQuery();

  useEffect(() => {
    if (isLoading || isInitializing) {

    } else {
      // Generisk BankID ger Criiptos väljare (denna enhet + QR/annan enhet). Utan
      // acr_values skickar prod-tenanten numera direkt till "denna enhet", vilket
      // fastnar på "Startar BankID-applikationen" på datorer utan BankID installerat.
      loginWithRedirect({ acrValues: 'urn:grn:authn:se:bankid' });
    };

    // loginWithRedirect avsiktligt utanför dep-listan — som beroende byter den
    // identitet mellan renders och skulle trigga om redirecten i en loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isInitializing]);

  useEffect(() => {
    const callback = query.get("callback");
    if(callback) {
        setCookie('callbackURI', callback);
    }

    // Ska bara läsas en gång vid mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

    return (<React.Fragment>
      {result?.error ? (
        <p>
          An error occured: {result.error} ({result.error_description}). Please try again:
        </p>
      ) : null}
      <div className='container'>
          <p className='loading'>Laddar</p>
      </div>
    </React.Fragment>)
}

export default Signature;
